module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer-container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.displayDate))]), _vm._v(" "), _c('div', {
    staticClass: "go-back"
  }, [_c('Back', {
    attrs: {
      "clicked": _vm.goBack
    }
  })], 1), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('router-view', {
    on: {
      "reload": function($event) {
        return _vm.fetch(true)
      }
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "snowflake"
  }), _vm._v(" "), _c('p', {
    staticClass: "booking-id text-sm"
  }, [_vm._v("\n    Bokningsnummer: " + _vm._s(_vm.order.resvid) + "\n  ")]), _vm._v(" "), (_vm.orderTypeSingle === 'accomodation') ? _c('div', {
    staticClass: "accomodation-outer"
  }, [_c('div', {
    staticClass: "accomodation-rows"
  }, _vm._l((_vm.order.details.rows.accomodation), function(row) {
    return _c('div', {
      key: row.rowid
    }, [(row.accommodation) ? _c('div', {
      staticClass: "accommodation"
    }, [_c('div', {
      staticClass: "accommodation-image",
      style: ((row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image)) ? 'background-image:url(' + (row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image)) + ')' : 'background-size: cover;')
    }), _vm._v(" "), _c('div', {
      staticClass: "booking-facts"
    }, [_c('p', {
      staticClass: "booking-title"
    }, [_vm._v("\n                " + _vm._s(row.accommodation.display_name || row.accommodation.description_title)), (row.accommodation.subtitle) ? _c('span', [_vm._v(" – " + _vm._s(row.accommodation.subtitle))]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "arrival-date"
    }, [_vm._v("\n                " + _vm._s(_vm._f("dateRange")([_vm.order.details.firstDate, _vm.order.details.lastDate], 'long', ' – ')) + "\n              ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1.5rem"
      }
    }, [_vm._v("\n                Incheckning: " + _vm._s(row.accommodation.check_in_time)), _c('br'), _vm._v("\n                Utcheckning: " + _vm._s(row.accommodation.check_out_time) + "\n              ")]), _vm._v(" "), (!_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
      staticStyle: {
        "margin-top": "0.5rem"
      }
    }, [_vm._v("\n                " + _vm._s(row.accommodation.direct_incheck ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[1].title : _vm.SITE_CONFIG.settings.SettingLockTypes.texts[0].title) + ": \n                " + _vm._s(row.accommodation.direct_incheck ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[1].description : _vm.SITE_CONFIG.settings.SettingLockTypes.texts[0].description) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.settings.SettingLockTypes.active && row.accommodation.lock_type_id) ? _c('div', {
      staticStyle: {
        "margin-top": "0.5rem"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[row.accommodation.lock_type_id].title) + ": " + _vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[row.accommodation.lock_type_id].description) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "2rem",
        "margin-bottom": "1rem"
      }
    }, [_c('UnitFacts', {
      attrs: {
        "unit": row.accommodation,
        "small": true
      }
    })], 1)])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "links only-large-screen"
  }, _vm._l((_vm.links(1)), function(link, key) {
    return _c('a', {
      key: 'links1-' + key,
      attrs: {
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.orderTypeSingle !== 'accomodation') ? _c('div', [_c('div', {
    staticClass: "other"
  }, [_c('div', {
    staticClass: "other-image",
    style: ('background-image:url(' + 'https://cdn.branasgruppen.se/branas/app/uploads/2023/10/27141148/familjmedskidor_hero.jpg' + ');')
  }), _vm._v(" "), _c('div', {
    staticClass: "booking-facts"
  }, [_c('div', [_c('p', {
    staticClass: "booking-title"
  }, [_vm._v("\n              " + _vm._s(_vm.orderTypeVisual) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "arrival-date"
  }, [_vm._v("\n              " + _vm._s(_vm._f("dateRange")([_vm.order.details.firstDate, _vm.order.details.lastDate], 'long', ' – ')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "links only-large-screen"
  }, _vm._l((_vm.links(1)), function(link, key) {
    return _c('a', {
      key: 'links1-' + key,
      attrs: {
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "booking-checkboxes"
  }, _vm._l((_vm.categories), function(cat) {
    return _c('div', {
      key: cat.slug,
      staticClass: "row-wrap"
    }, [_c('div', {
      staticClass: "row-header"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('Checkbox', {
      attrs: {
        "label": "",
        "label-position": "right",
        "value": cat.has
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "category"
    }, [_vm._v(_vm._s(cat.title))]), _vm._v(" "), (cat.slug === 'rental') ? _c('div', {
      staticClass: "actions"
    }, [(cat.has) ? _c('button', {
      staticClass: "button--rounded--outlined",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openRental = !_vm.openRental
        }
      }
    }, [_vm._v(_vm._s(_vm.openRental ? 'Dölj' : 'Visa'))]) : _vm._e(), _vm._v(" "), (!cat.has) ? _c('button', {
      staticClass: "button--rounded",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.bookMoreWithLink(cat.link, _vm.order)
        }
      }
    }, [_vm._v("Boka nu")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (cat.slug === 'skipass') ? _c('div', {
      staticClass: "actions"
    }, [(cat.has) ? _c('button', {
      staticClass: "button--rounded--outlined",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openSkipass = !_vm.openSkipass
        }
      }
    }, [_vm._v(_vm._s(_vm.openSkipass ? 'Dölj' : (_vm.showQrCodeButton ? 'Visa mer, QR-koder' : 'Visa')))]) : _vm._e(), _vm._v(" "), (!cat.has) ? _c('button', {
      staticClass: "button--rounded",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.bookMoreWithLink(cat.link, _vm.order)
        }
      }
    }, [_vm._v("Boka nu")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (cat.slug === 'skischool') ? _c('div', {
      staticClass: "actions"
    }, [(cat.has) ? _c('button', {
      staticClass: "button--rounded--outlined",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openSkischool = !_vm.openSkischool
        }
      }
    }, [_vm._v(_vm._s(_vm.openSkischool ? 'Dölj' : 'Visa'))]) : _vm._e(), _vm._v(" "), (!cat.has) ? _c('button', {
      staticClass: "button--rounded",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.bookMoreWithLink(cat.link, _vm.order)
        }
      }
    }, [_vm._v("Boka nu")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (cat.slug === 'accomodation') ? _c('div', {
      staticClass: "actions"
    }, [(cat.has) ? _c('button', {
      staticClass: "button--rounded--outlined",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goToAccommodation(cat.product_slug)
        }
      }
    }, [_vm._v("Visa boende")]) : _vm._e(), _vm._v(" "), (!cat.has) ? _c('button', {
      staticClass: "button--rounded",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.bookMoreWithLink(cat.link, _vm.order)
        }
      }
    }, [_vm._v("Boka nu")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row-content"
    }, [(_vm.openSkipass && cat.slug === 'skipass' && _vm.showQrCodeButton) ? _c('button', {
      staticClass: "button--rounded--outlined qr-button",
      on: {
        "click": _vm.openQrModal
      }
    }, [_vm._v("QR-koder till liftkortsautomat")]) : _vm._e(), _vm._v(" "), _c('PrettyOrderDetails', {
      key: cat.slug + 'pod' + (new Date()),
      attrs: {
        "order": _vm.order,
        "types": [cat.slug],
        "variant": "mini",
        "openRental": _vm.openRental,
        "openSkipass": _vm.openSkipass,
        "openSkischool": _vm.openSkischool,
        "bookMoreCallback": _vm.bookMore
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "links only-small-screen"
  }, _vm._l((_vm.links(1)), function(link, key) {
    return _c('a', {
      key: 'links1-' + key,
      attrs: {
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))])
  }), 0), _vm._v(" "), (_vm.addons.length) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "booking-checkboxes booking-checkboxes--addons"
  }, _vm._l((_vm.addons), function(addon) {
    return _c('div', {
      key: addon.lid,
      staticClass: "row-wrap"
    }, [_c('div', {
      staticClass: "row-header"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('Checkbox', {
      attrs: {
        "label": "",
        "label-position": "right",
        "value": _vm.hasAddons.indexOf(addon.lid) !== -1
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "category"
    }, [_vm._v(_vm._s(addon.arttext))]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [(!addon.added) ? _c('button', {
      staticClass: "button--rounded--outlined",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.bookAddon()
        }
      }
    }, [_vm._v("Boka")]) : _vm._e()])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-box",
    staticStyle: {
      "margin": "4rem 0 2rem 0"
    }
  }, [_vm._v("\n      Vid ändringar kontakta gästservice på 054-13 26 00\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin": "4rem 2rem 2rem 2rem"
    }
  }, [_c('button', {
    staticClass: "button--rounded",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToBooking(_vm.order.headlid)
      }
    }
  }, [_vm._v("Fler detaljer")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "outer-links"
  }, _vm._l((_vm.links(2)), function(link, key) {
    return _c('div', {
      key: 'links2-' + key
    }, [_c('div', {
      staticClass: "icon-wrapper"
    }, [_c('icon', {
      attrs: {
        "name": "arrow-white",
        "scale": 0.7
      }
    })], 1), _vm._v(" "), _c('a', {
      attrs: {
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))])])
  }), 0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addon-title"
  }, [_c('h2', [_vm._v("Populära tillval")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19943910"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/MyPages/MyBookingV2.vue
// module id = 909
// module chunks = 0